/**
 * Generates an exact local calendar date string in YYYY-MM-DD format.
 * This guarantees consistency across components and prevents time-zone shifts.
 * @returns {string} e.g. "2026-07-28"
 */
export const getLocalTodayString = () => {
  const localToday = new Date();
  const year = localToday.getFullYear();
  const month = String(localToday.getMonth() + 1).padStart(2, '0');
  const day = String(localToday.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};
